/* Excel Filters — faceted collection filter.
   Builds Pack size / Brand / Filter area / Availability facets from each card's data-*
   attributes, filters the grid client-side (AND across groups, OR within a group), shows
   live counts + removable active chips, and runs as an off-canvas drawer on mobile. */
(function () {
  'use strict';

  var ROOT = '[data-ef-collf]';
  var PANEL = '[data-ef-collection-filters]';
  var BODY = '[data-ef-filter-body]';
  var GRID = '.ef-coll-grid';
  var CARD = '.ef-coll-card';

  var CHEVRON = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="m6 9 6 6 6-6"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" width="12" height="12" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" d="M4 12.5 9.5 18 20 6.5"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" width="13" height="13" aria-hidden="true"><path fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" d="M6 6l12 12M18 6 6 18"/></svg>';

  var SQFT_BANDS = [
    { key: 'u50', label: 'Under 50 sq ft', test: function (n) { return n < 50; } },
    { key: '50-100', label: '50–100 sq ft', test: function (n) { return n >= 50 && n < 100; } },
    { key: '100-200', label: '100–200 sq ft', test: function (n) { return n >= 100 && n < 200; } },
    { key: '200-400', label: '200–400 sq ft', test: function (n) { return n >= 200 && n < 400; } },
    { key: 'o400', label: '400+ sq ft', test: function (n) { return n >= 400; } }
  ];
  var PACK_ORDER = ['1', '2', '3', '4', '5', '6', '8', '10', '12', '15'];

  function el(tag, attrs, kids) {
    var node = document.createElement(tag);
    if (attrs) {
      Object.keys(attrs).forEach(function (k) {
        if (k === 'text') node.textContent = attrs[k];
        else if (k === 'html') node.innerHTML = attrs[k];
        else if (attrs[k] !== null && attrs[k] !== undefined) node.setAttribute(k, attrs[k]);
      });
    }
    (kids || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function num(v) { var m = String(v || '').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; }
  function sqftBand(card) {
    var n = num(card.getAttribute('data-sqft'));
    if (n === null) return null;
    for (var i = 0; i < SQFT_BANDS.length; i++) if (SQFT_BANDS[i].test(n)) return SQFT_BANDS[i].key;
    return null;
  }

  function init() {
    var root = document.querySelector(ROOT);
    var panel = document.querySelector(PANEL);
    var body = panel && panel.querySelector(BODY);
    var grid = document.querySelector(GRID);
    if (!root || !panel || !body || !grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll(CARD));
    var deferred = grid.querySelector('[data-ef-deferred-cards]');
    if (deferred && deferred.content) {
      cards = cards.concat(Array.prototype.slice.call(deferred.content.querySelectorAll(CARD)));
    }
    if (!cards.length) { panel.setAttribute('hidden', ''); return; } /* empty collection: hide the shell instead of leaving "Loading filters…" forever */
    window.EFCollectionCards = cards;
    var order = new Map();
    cards.forEach(function (c, i) { order.set(c, i); });

    /* ---- accessors ---- */
    var packOf = function (c) { return (c.getAttribute('data-pack') || '').trim(); };
    // Brand facet prefers partnumber/fits signals (data-fits), then brand-collection membership
    // (data-brands). Unioning both lets hub ?brand=jacuzzi work even when the branded
    // collection membership is still incomplete.
    var brandsOf = function (c) {
      var fits = (c.getAttribute('data-fits') || '').trim();
      var brands = (c.getAttribute('data-brands') || '').trim();
      var set = {};
      (fits + ' ' + brands).trim().split(/\s+/).forEach(function (x) { if (x) set[x] = true; });
      return Object.keys(set);
    };
    var titleCase = function (s) { return String(s).split('-').map(function (w) { return w ? w.charAt(0).toUpperCase() + w.slice(1) : w; }).join('-'); };
    var inStock = function (c) { return c.getAttribute('data-instock') === '1'; };
    var isSpa = function (c) { return c.getAttribute('data-spa') === '1'; };
    var hasValue = function (c, key, val) {
      if (key === 'pack') return packOf(c) === val;
      if (key === 'brand') return brandsOf(c).indexOf(val) !== -1;
      if (key === 'sqft') return sqftBand(c) === val;
      if (key === 'stock') return inStock(c);
      if (key === 'spa') return (val === '1') === isSpa(c);
      return false;
    };

    /* ---- build the facet model from the cards present ---- */
    var groups = [];

    var packVals = {};
    cards.forEach(function (c) { var p = packOf(c); if (p) packVals[p] = true; });
    var packOpts = PACK_ORDER.filter(function (p) { return packVals[p]; }).map(function (p) { return { value: p, label: p + '-Pack' }; });
    if (packOpts.length > 1) groups.push({ key: 'pack', label: 'Pack size', kind: 'pills', options: packOpts });

    var brandSet = {};
    cards.forEach(function (c) { brandsOf(c).forEach(function (b) { if (b) brandSet[b] = true; }); });
    var brandOpts = Object.keys(brandSet).map(function (k) { return { value: k, label: titleCase(k) }; })
      .sort(function (a, b) { return a.label.localeCompare(b.label); });
    if (brandOpts.length && !panel.hasAttribute('data-ef-hide-brand')) groups.push({ key: 'brand', label: 'Brand', kind: 'list', options: brandOpts });

    var bandsPresent = {};
    cards.forEach(function (c) { var b = sqftBand(c); if (b) bandsPresent[b] = true; });
    var sqftOpts = SQFT_BANDS.filter(function (b) { return bandsPresent[b.key]; }).map(function (b) { return { value: b.key, label: b.label }; });
    if (sqftOpts.length > 1) groups.push({ key: 'sqft', label: 'Filter area', kind: 'list', options: sqftOpts });

    var hasSpaCards = cards.some(isSpa);
    var hasPoolCards = cards.some(function (c) { return !isSpa(c); });
    if (hasSpaCards && hasPoolCards) {
      groups.push({ key: 'spa', label: 'Type', kind: 'list', options: [
        { value: '0', label: 'Pool cartridges' },
        { value: '1', label: 'Spa cartridges' }
      ] });
    }

    var hasOut = cards.some(function (c) { return !inStock(c); });
    if (hasOut) groups.push({ key: 'stock', label: 'Availability', kind: 'list', options: [{ value: 'instock', label: 'In stock only' }] });

    if (!groups.length) { panel.setAttribute('hidden', ''); return; }

    /* ---- render facet UI ---- */
    body.innerHTML = '';
    groups.forEach(function (g) {
      var det = el('details', { class: 'ef-collf-group', open: '' });
      var sum = el('summary', { class: 'ef-collf-group__summary' }, [
        el('span', { class: 'ef-collf-group__label', text: g.label }),
        el('span', { class: 'ef-collf-group__chev', html: CHEVRON })
      ]);
      det.appendChild(sum);
      var opts = el('div', { class: 'ef-collf-group__opts' + (g.kind === 'pills' ? ' is-pills' : '') });
      g.options.forEach(function (o) {
        var input = el('input', { type: 'checkbox', name: g.key, value: o.value });
        input.className = 'ef-collf-input';
        var label;
        if (g.kind === 'pills') {
          label = el('label', { class: 'ef-collf-pill' }, [input, el('span', { text: o.label })]);
        } else {
          label = el('label', { class: 'ef-collf-opt' }, [
            input,
            el('span', { class: 'ef-collf-opt__box', html: CHECK }),
            el('span', { class: 'ef-collf-opt__label', text: o.label }),
            el('span', { class: 'ef-collf-opt__count' })
          ]);
        }
        label.setAttribute('data-ef-opt', g.key + '::' + o.value);
        opts.appendChild(label);
      });
      det.appendChild(opts);
      body.appendChild(det);
    });

    /* ---- references ---- */
    var inputs = Array.prototype.slice.call(body.querySelectorAll('.ef-collf-input'));
    var countEls = qa('[data-ef-filter-count]');
    var applyCountEls = qa('[data-ef-apply-count]');
    var activeWrap = document.querySelector('[data-ef-active-pills]');
    var activeBadge = document.querySelector('[data-ef-active-count]');
    var emptyEl = document.querySelector('[data-ef-filter-empty]');
    var sortSel = document.querySelector('[data-ef-sort]');
    var total = cards.length;

    function qa(sel) { return Array.prototype.slice.call(document.querySelectorAll(sel)); }

    function readState() {
      var s = { pack: [], brand: [], sqft: [], spa: [], stock: false };
      inputs.forEach(function (i) {
        if (!i.checked) return;
        if (i.name === 'stock') s.stock = true;
        else if (s[i.name]) s[i.name].push(i.value);
      });
      return s;
    }

    function matchesExcept(c, s, except) {
      if (except !== 'pack' && s.pack.length && s.pack.indexOf(packOf(c)) === -1) return false;
      if (except !== 'brand' && s.brand.length) {
        var bs = brandsOf(c), bok = false;
        for (var bi = 0; bi < bs.length; bi++) if (s.brand.indexOf(bs[bi]) !== -1) { bok = true; break; }
        if (!bok) return false;
      }
      if (except !== 'sqft' && s.sqft.length) { var b = sqftBand(c); if (!b || s.sqft.indexOf(b) === -1) return false; }
      if (except !== 'spa' && s.spa.length === 1 && ((s.spa[0] === '1') !== isSpa(c))) return false;
      if (except !== 'stock' && s.stock && !inStock(c)) return false;
      return true;
    }
    function matches(c, s) { return matchesExcept(c, s, null); }

    function labelFor(key, val) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].key !== key) continue;
        for (var j = 0; j < groups[i].options.length; j++) if (groups[i].options[j].value === val) return groups[i].options[j].label;
      }
      return val;
    }

    function renderActive(s) {
      if (!activeWrap) return;
      activeWrap.innerHTML = '';
      var items = [];
      ['pack', 'brand', 'sqft', 'spa'].forEach(function (k) { s[k].forEach(function (v) { items.push({ key: k, value: v }); }); });
      if (s.stock) items.push({ key: 'stock', value: 'instock' });
      items.forEach(function (it) {
        var chip = el('button', { type: 'button', class: 'ef-collf-chip', 'data-ef-remove': it.key + '::' + it.value }, [
          el('span', { text: labelFor(it.key, it.value) }),
          el('span', { class: 'ef-collf-chip__x', html: CLOSE })
        ]);
        activeWrap.appendChild(chip);
      });
      if (items.length) {
        activeWrap.appendChild(el('button', { type: 'button', class: 'ef-collf-chip ef-collf-chip--clear', 'data-ef-filter-clear': '', text: 'Clear all' }));
      }
      activeWrap.hidden = items.length === 0;
      if (activeBadge) {
        activeBadge.textContent = items.length ? String(items.length) : '';
        activeBadge.hidden = items.length === 0;
      }
    }

    function updateCounts(s) {
      groups.forEach(function (g) {
        g.options.forEach(function (o) {
          var n = 0;
          for (var i = 0; i < cards.length; i++) if (matchesExcept(cards[i], s, g.key) && hasValue(cards[i], g.key, o.value)) n++;
          var lbl = body.querySelector('[data-ef-opt="' + g.key + '::' + o.value + '"]');
          if (!lbl) return;
          var cEl = lbl.querySelector('.ef-collf-opt__count');
          if (cEl) cEl.textContent = n ? String(n) : '';
          var input = lbl.querySelector('input');
          var disable = n === 0 && !(input && input.checked);
          lbl.classList.toggle('is-disabled', disable);
          if (input) input.disabled = disable;
        });
      });
    }

    function applySort() {
      var v = sortSel ? sortSel.value : 'featured';
      var arr = cards.slice();
      if (v === 'price-asc') arr.sort(function (a, b) { return (num(a.getAttribute('data-price')) || 0) - (num(b.getAttribute('data-price')) || 0); });
      else if (v === 'price-desc') arr.sort(function (a, b) { return (num(b.getAttribute('data-price')) || 0) - (num(a.getAttribute('data-price')) || 0); });
      else arr.sort(function (a, b) { return order.get(a) - order.get(b); });
      cards = arr;
      window.EFCollectionCards = cards;
      document.dispatchEvent(new CustomEvent('ef:collf:applied'));
    }

    function apply() {
      var s = readState();
      var visible = 0;
      cards.forEach(function (c) { var show = matches(c, s); c.hidden = !show; if (show) visible++; });
      countEls.forEach(function (e) { e.textContent = String(visible); });
      applyCountEls.forEach(function (e) { e.textContent = visible === total ? 'all' : String(visible); });
      if (emptyEl) emptyEl.hidden = visible > 0;
      updateCounts(s);
      renderActive(s);
      writeUrl(s);
      document.dispatchEvent(new CustomEvent('ef:collf:applied'));
    }

    /* ---- URL state ---- */
    function writeUrl(s) {
      var p = new URLSearchParams(window.location.search);
      ['pack', 'brand', 'sqft'].forEach(function (k) { p.delete(k); if (s[k].length) p.set(k, s[k].join(',')); });
      p.delete('spa'); if (s.spa.length === 1) p.set('spa', s.spa[0]);
      p.delete('stock'); if (s.stock) p.set('stock', '1');
      var q = p.toString();
      window.history.replaceState({}, '', q ? window.location.pathname + '?' + q : window.location.pathname);
    }
    function restoreUrl() {
      var p = new URLSearchParams(window.location.search);
      function set(name) {
        var raw = p.get(name); if (!raw) return;
        var vals = raw.split(',');
        inputs.forEach(function (i) { if (i.name === name && vals.indexOf(i.value) !== -1) i.checked = true; });
      }
      ['pack', 'brand', 'sqft', 'spa'].forEach(set);
      if (p.get('stock') === '1') inputs.forEach(function (i) { if (i.name === 'stock') i.checked = true; });
    }

    function clearAll() {
      inputs.forEach(function (i) { i.checked = false; });
      apply();
    }

    /* ---- mobile drawer ---- */
    var openBtn = document.querySelector('[data-ef-filter-open]');
    function openDrawer() {
      root.classList.add('is-filter-open');
      document.body.classList.add('ef-collf-lock');
      if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
      var first = body.querySelector('input, button, summary');
      if (first) first.focus();
    }
    function closeDrawer() {
      root.classList.remove('is-filter-open');
      document.body.classList.remove('ef-collf-lock');
      if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); openBtn.focus(); }
    }

    /* ---- wire events ---- */
    body.addEventListener('change', function (e) { if (e.target.matches('.ef-collf-input')) apply(); });

    document.addEventListener('click', function (e) {
      var remove = e.target.closest('[data-ef-remove]');
      if (remove) {
        var token = remove.getAttribute('data-ef-remove');
        inputs.forEach(function (i) { if (i.name + '::' + i.value === token) i.checked = false; });
        apply();
        return;
      }
      if (e.target.closest('[data-ef-filter-clear]')) { clearAll(); return; }
      if (e.target.closest('[data-ef-filter-open]')) { openDrawer(); return; }
      if (e.target.closest('[data-ef-filter-close]') || e.target.closest('[data-ef-filter-apply]')) { closeDrawer(); return; }
      if (e.target.matches('[data-ef-collf-overlay]')) { closeDrawer(); }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-filter-open')) closeDrawer();
    });

    if (sortSel) sortSel.addEventListener('change', applySort);

    /* ---- go ---- */
    restoreUrl();
    apply();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
